module.exports = __webpack_public_path__ + "static/media/fondo_planner.6d78f718.jpg";